import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  results: [],
  error: null,
};
export default reducerFactory(initialState, {
  [types.GET_PERIOD_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.GET_PERIOD_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    ...response.period,
  }),
  [types.GET_PERIOD_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
